declare const COUNTERS: string

function isUseCounters(): boolean {
  return COUNTERS === 'true'
}

export {isUseCounters}
